// extracted by mini-css-extract-plugin
export default {"infoIcon":"ColumnInfo_infoIcon__pU-HH","infoTooltip":"ColumnInfo_infoTooltip__myp0A"};